import type {Express} from 'express';
import {MAX_FILE_SIZE} from '../constant';

export function isFilesOverLimitSize(files: Express.Multer.File[] | File[]) {
  const totalFileSize = files.reduce((acc, file) => acc + file.size, 0);

  return totalFileSize > MAX_FILE_SIZE;
}
